module.exports = __webpack_public_path__ + "static/media/salesforce_round.5d7cc0fe.png";